import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Stats from './components/Stats';
import About from './components/About';
import Clients from './components/Clients';
import QualityPolicies from './components/QualityPolicies';
import QualityValues from './components/QualityValues';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-slate-900 min-h-screen">
      <Navbar />
      <Hero />
      <Stats />
      <Services />
      <About />
      <Clients />
      <QualityPolicies />
      <QualityValues />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
